import type { CourierDeliveryStatus } from 'common/api/api-types';

import { formatDistanceToNowStrict } from 'date-fns';

import { getDeliveryEstimatedTimeOfArrival, getIdleTime } from 'common/utils/courierUtils';
import { addLate } from 'common/utils/timeUtils';

export const getTail = ({
  deliveryStatus,
  courierStatusUpdatedAt,
}: {
  courierStatusUpdatedAt?: Date;
  deliveryStatus?: CourierDeliveryStatus;
}) => {
  let result = '';

  // for a bundle of tasks
  switch (deliveryStatus?.status) {
    case 'pick_up':
    case 'drop_off':
      if ((deliveryStatus.tasks?.length ?? 0) > 1) {
        return ` (${deliveryStatus.tasks?.length ?? 0})`;
      }
  }

  // for single task or others
  switch (deliveryStatus?.status) {
    case 'pick_up':
    case 'drop_off':
    case 'idle':
    case 'unknown': {
      const estimatedTimeOfArrival =
        deliveryStatus.status === 'idle'
          ? getIdleTime({
              courierStatusUpdatedAt,
              deliveryStatusUpdatedAt: deliveryStatus.updatedAt,
            })
          : getDeliveryEstimatedTimeOfArrival(deliveryStatus);

      if (estimatedTimeOfArrival) {
        result = formatDistanceToNowStrict(estimatedTimeOfArrival);

        if (deliveryStatus.status === 'pick_up' || deliveryStatus.status === 'drop_off') {
          result += addLate(estimatedTimeOfArrival);
        }
      }

      break;
    }
    default:
      if (courierStatusUpdatedAt) {
        result = formatDistanceToNowStrict(courierStatusUpdatedAt);
      }
  }

  return result ? ` ${result}` : '';
};

export const getHead = ({
  deliveryStatus,
  prefixIdle,
}: {
  prefixIdle?: string;
  deliveryStatus?: CourierDeliveryStatus;
}) => {
  // for a bundle of tasks
  switch (deliveryStatus?.status) {
    case 'pick_up':
    case 'drop_off':
      if ((deliveryStatus.tasks?.length ?? 0) > 1) {
        return 'Bundle';
      }
  }

  // for single task or others
  switch (deliveryStatus?.status) {
    case 'pick_up':
      return 'Pickup';
    case 'drop_off':
      return 'Dropoff';
    case 'idle':
      return prefixIdle ?? '';
    case 'unknown':
  }

  return '';
};
